export default __webpack_public_path__ + "images/application-complete-logo.svg";